import { render, staticRenderFns } from "./LaskutusTuo.vue?vue&type=template&id=3d1bd5da&scoped=true&"
import script from "./LaskutusTuo.vue?vue&type=script&lang=js&"
export * from "./LaskutusTuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1bd5da",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1bd5da')) {
      api.createRecord('3d1bd5da', component.options)
    } else {
      api.reload('3d1bd5da', component.options)
    }
    module.hot.accept("./LaskutusTuo.vue?vue&type=template&id=3d1bd5da&scoped=true&", function () {
      api.rerender('3d1bd5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LaskutusTuo.vue"
export default component.exports